import { IHydratedManifest } from '@utils/m3u8Hydrator/m3u8Hydrator';

export const getPartHoldback: (manifest: IHydratedManifest, defaultValue: number) => number = (
  manifest: IHydratedManifest,
  defaultValue: number,
): number => {
  return manifest.partHoldBack || manifest.serverControl?.partHoldBack || manifest.serverControl?.holdBack || defaultValue;
};
